import { useState } from "react";
import { TourSteps } from "../../../globalHooks/use-render-global-tour";

export default function useBuildTourSteps(){
  const [isTourOpen, setIsTourOpen] = useState(false);
  
const steps: TourSteps[] = [
  {
    selector: '.title-component', 
    content: (
      <>
        <strong>Visão Geral do Aprendiz</strong>
        <div>Aqui você pode visualizar os dados do Aprendiz e dos Visionários, incluindo matrículas em andamento, extrato de pagamentos e a situação atual do aluno.</div>
      </>
    ),
    position: 'bottom',
  },
  {
    selector: '.student-basic-info-wrapper', 
    content: (
      <>
        <strong>Currículos em Andamento</strong>
        <div>Confira todos os currículos e turmas em que o aprendiz está matriculado, assim como upgrades disponíveis.</div>
      </>
    ),
    position: 'top',
  },
  {
    selector: '.box-aluno',
    content: (
      <>
        <strong>Dados Básicos</strong>
        <div>Consulte e edite informações pessoais, documentos e status do aprendiz. Use o botão &quot;Editar&quot; para alterar dados quando necessário.</div>
      </>
    ),
    position: 'right',
  },
  {
    selector: '.resposavel-revisao', 
    content: (
      <>
        <strong>Visionários</strong>
        <div>Visualize os dados dos visionários, grau de parentesco, contatos e clique para ver detalhes adicionais e alterar informações.</div>
      </>
    ),
    position: 'top',
  },
  {
    selector: '.tabela', 
    content: (
      <>
        <strong>Extratos Financeiros</strong>
        <div>Consulte todas as cobranças, status de pagamento, valor, tipo, vencimento, além de ações disponíveis como alterar forma de pagamento e emitir segunda via.</div>
      </>
    ),
    position: 'top',
  },
];
    return {
      steps,
      isTourOpen,
      setIsTourOpen,
    };
}